export function GetLocalStorageCache(name) {
    return JSON.parse(localStorage.getItem(name));
}

export function SetLocalStorageCache(name, cols) {
    localStorage.setItem(name, JSON.stringify(cols));
}